import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthStore } from '../store/auth.store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly store = inject(AuthStore);

  canActivate(): boolean {
    return this.store.checkAuthenticationAndRedirect();
  }
}
